<template>
	<div class="slot-card flex-column flex-centerize px-6 py-12">
		<div class="slot-title mb-2">Enter confirmation code</div>
		<p>
			We emailed you a verification code to {{ email }}. <br />
			Enter the code below to confirm your email.
		</p>
		<div class="otp-input-container display-flex flex-row mt-6">
			<v-otp-input :error="isCodeWrong" @finish="(code) => $emit('code-submitted', code)" type="number" length="4"></v-otp-input>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PortalAuthEnterCode',
	props: {
		email: { type: String, required: true },
		isCodeWrong: { type: Boolean, default: false },
		logoUrl: { type: String },
	},

	data: () => ({
		verificationCode: '',
	}),
};
</script>

<style scoped lang="scss">
.otp-input-container {
	::v-deep {
		.v-text-field__slot {
			height: 91px;
			padding: 0px;
			max-width: 70px;
			box-shadow: 0px 3px 10px #00000029;
		}
		.v-input__slot {
			min-height: 91px !important;
		}
	}
}
.slot-card {
	min-width: 470px;
	max-width: 760px;
	text-align: center;
	border-radius: 28px;
	background: var(--bg-color);
	@media (max-width: 600px) {
		min-width: calc(100% - 20px);
		max-width: calc(100% - 20px);
		padding: 18px 10px 28px 10px;
	}
	box-shadow: 0px 13px 30px 0px #00000040;
}
</style>
